import { FC, ReactNode, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

type PortalComponentProps = {
  selector: string;
  children: ReactNode;
  shouldUseOriginalNodeContent: boolean;
};

const PortalComponent: FC<PortalComponentProps> = ({
  selector,
  children,
  shouldUseOriginalNodeContent,
}: PortalComponentProps) => {
  const ref = useRef<NodeListOf<HTMLElement> | null>(null);

  useEffect(() => {
    ref.current = document.querySelectorAll(selector);
    clearCTABlockContent();
    if (shouldUseOriginalNodeContent) {
      enableOriginalNodeContent();
    }
    function enableOriginalNodeContent() {
      if (!ref.current) {
        return;
      }
      ref.current.forEach((node) => {
        const anchorChildren = node.querySelectorAll('a');
        anchorChildren.forEach((anchor) => {
          anchor.style.display = 'inline-block';
        });
      });
    }
    function clearCTABlockContent() {
      if (!ref.current) {
        return;
      }
      ref.current.forEach((node) => {
        const anchorChildren = node.querySelectorAll('a');
        anchorChildren.forEach((anchor) => {
          anchor.style.display = 'none';
        });
      });
    }
  }, [selector, children, shouldUseOriginalNodeContent]);

  if (!ref.current) {
    return null;
  }

  return <>{Array.from(ref.current).map((node) => createPortal(children, node))}</>;
};

export default PortalComponent;
